import App from '@/App.vue'
import router from '@/router'
import i18n from '@/i18n'
// import initWP from '@/utils/webpush'
import { createPinia } from 'pinia'
import { Lazyload, setToastDefaultOptions } from 'vant'
import { useSystemInfo, useUserInfo } from '@/store'
import { persistedState } from '@/store/plugins/persist'
import { PWALoginIframe } from '@/hooks/usePWAJumpIframe'
import { isInIframe, isInAndroidApp } from '@/env'
import { ev } from './consts'
import initVconsole from '@/utils/initVconsole'
import { isServe, isBuild, isProd, showVconsole } from '@/env'
if (isServe || (isBuild && !isProd) || showVconsole) {
  initVconsole()
}


const app = createApp(App)

const pinia = createPinia()
pinia.use(persistedState)
console.log(new Date().getTime(), 22222)
app.use(pinia)
app.use(i18n)
app.use(router)
app.use(Lazyload)

app.config.errorHandler = (err, instance, info) => {
  console.error('errorHandler', err, instance, info)
}

setToastDefaultOptions({
  forbidClick: true,
  zIndex: 999,
  wordBreak: 'break-word',
})

app.config.performance = true

ev.on('login', () => {
  // console.log('on login')
  const userInfo = useUserInfo().userInfo!
  if (isInIframe) {
    userInfo.un_flag = localStorage.getItem('un_flag')
    userInfo.ps_flag = localStorage.getItem('ps_flag')
    window.parent.postMessage(
      // 通知主PWA登录成功
      {
        type: 'LOGIN',
        payload: {
          userInfo: JSON.stringify(userInfo),
        },
      },
      '*',
    )
  }

  if (isInAndroidApp) {
    window.jsBridge.postMessage('setSession', JSON.stringify(userInfo))
    // window.jsBridge.postMessage(
    //   'setUserInfo',
    //   JSON.stringify(userInfo),
    // )
  }
})

ev.on('restore', (d: any) => {
  // console.log('on restore', d, d[0].userInfo, d[0].userInfo?.token)
  if (d[0].userInfo && d[1].$id === 'userInfo')
    useUserInfo().login(d[0].userInfo, d[0].userInfo?.token, true)
})

ev.on('logout', () => {
  // console.log('on logout')
  if (isInIframe) {
    // 通知主PWA登出
    window.parent.postMessage({ type: 'LOGOUT' }, '*')
  }

  if (isInAndroidApp) {
    // 通知安卓登出
    window.jsBridge.postMessage('setSession', '')
  }
})

useUserInfo().checkToLogin()

const systemInfo = useSystemInfo()
systemInfo.$subscribe((_, state) => {
  i18n.global.locale = state.language as 'en' | 'pt'

  if (
    router.currentRoute.value.path !== '/maintain' &&
    state.merchantConfig &&
    state.merchantConfig.siteStatus !== 'Normal'
  ) {
    router.replace('/maintain')
  }
  

  if (router.currentRoute.value.path == '/maintain' && state.merchantConfig && state.merchantConfig.siteStatus === 'Normal') {
    router.replace('/')
  }

  if (router.currentRoute.value.path == '/maintain' && state.merchantConfig && state.merchantConfig.siteStatus === 'Normal') {
    router.replace('/')
  }

  // if (state.merchantConfig && state.merchantConfig.siteStatus === 'Normal') {
  //   router.replace('/')
  // }
})

systemInfo
  .init()
  .then(() => {
    // initWP()
    app.mount('#app')
  })
  .catch((e) => {
    showFailToast({
      iconSize: 30,
      message: 'Failed to init, please try later',
      duration: 0,
    })

    
    const { t } = i18n.global
    showDialog({
      title: t('InitDialog.title'),
      message: t('InitDialog.message'),
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: t('InitDialog.confirmButtonText'), 
      className:'initfailed-dialog pointer-events-auto [&_*]:pointer-events-auto',
      theme:'round-button',
      // teleport:'body',
      beforeClose:(action)=>{
        console.log('beforeClose:',action);
        if (action === 'confirm') {
          location.reload();
        }
      },
    })

    document.body.classList.add('defaultBg')
    console.error('init error', e)
  })

if (!isInIframe) PWALoginIframe()
